import { ObjectHelper } from 'apps/idl/src/helpers/objectHelper';

export class ExportError extends Error {

	constructor(psMessage: string) {
		super(psMessage);
		// Nécessaire pour que le 'instanceof ExportError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, ExportError);
	}

}